import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import MainApp from "../../layouts/MainApp";
import { adminActions } from "../../../redux/actions";

export default function Settings() {
  // let user = JSON.parse(localStorage.getItem("user"));
  // let teamId = JSON.parse(localStorage.getItem("teamId"));

  // let isCompany = user.data.team_roles[teamId].roles.includes("company");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(adminActions.getThirdPartyToken());
  }, [dispatch]);

  return (
    <MainApp>
      <div className="main-content-padding">
        <div className="main-content">
          <div className="mb-2  d-flex justify-content-between ">
            <h1 className="mr-2">Settings</h1>
          </div>
          <div className="separator-breadcrumb border-top" />

          <div className="row">
            <Link
              to={"/settings/third-party-token"}
              className="text-decoration-none"
            >
              <div
                className="card mt-5 ml-2"
                style={{ width: "343px", height: "180px" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Third party token</h2>

                  <p className="card-text">
                    This allows a third party to create and edit orders for your
                    company using the generated token.
                  </p>
                </div>
              </div>
            </Link>
            <Link
              to={"/settings/assign-roles"}
              className="text-decoration-none"
            >
              <div
                className="card mt-5 ml-4"
                style={{ width: "343px", height: "180px" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Assign roles</h2>

                  <p className="card-text">
                    This admin to assign roles and responsibilities to
                    employees.
                  </p>
                </div>
              </div>
            </Link>
            <Link to={"/settings/company"} className="text-decoration-none">
              <div
                className="card mt-5 ml-4"
                style={{ width: "343px", height: "180px", cursor: "pointer" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Company Settings</h2>

                  <p className="card-text">
                    Update your company settings.
                  </p>
                </div>
              </div>
            </Link>
             <Link to={"/settings/webhooks"} className="text-decoration-none">
              <div
                className="card mt-5 ml-4"
                style={{ width: "343px", height: "180px", cursor: "pointer" }}
              >
                <div className="card-body">
                  <h2 className="card-title mt-3">Webhooks</h2>

                  <p className="card-text">
                    Update your company settings.
                  </p>
                </div>
              </div>
            </Link>
          </div>
          {/* <div className="mb-4"><AssignRole /></div> */}
          {/* end of row*/}
          {/* end of main-content */}
        </div>
      </div>
    </MainApp>
  );
}
